module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tplheader'), _vm._v(" "), _c('tplLeftPanel'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "main-panel"
    }
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('inputbox', {
    attrs: {
      "id": "keyword",
      "keydownEnter": _vm.searchClick,
      "label": "Kártya szám / Név / Neptunkód",
      "name": "keyword"
    },
    model: {
      value: (_vm.search.keyword),
      callback: function($$v) {
        _vm.$set(_vm.search, "keyword", $$v)
      },
      expression: "search.keyword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('inputbox', {
    attrs: {
      "maxlength": "8",
      "inputCheck": "cardRf",
      "keydownEnter": _vm.searchClick,
      "id": "rfid",
      "label": "RF ID",
      "name": "rfid"
    },
    model: {
      value: (_vm.search.rfid),
      callback: function($$v) {
        _vm.$set(_vm.search, "rfid", $$v)
      },
      expression: "search.rfid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('combobox', {
    attrs: {
      "id": "type",
      "label": "Típus",
      "name": "type"
    },
    model: {
      value: (_vm.search.type),
      callback: function($$v) {
        _vm.$set(_vm.search, "type", $$v)
      },
      expression: "search.type"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('inputbox', {
    attrs: {
      "datepicker": "1",
      "id": "from",
      "label": "dátum -tól",
      "name": "from"
    },
    model: {
      value: (_vm.search.from),
      callback: function($$v) {
        _vm.$set(_vm.search, "from", $$v)
      },
      expression: "search.from"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('inputbox', {
    attrs: {
      "datepicker": "1",
      "id": "to",
      "label": "dátum -ig",
      "name": "to"
    },
    model: {
      value: (_vm.search.to),
      callback: function($$v) {
        _vm.$set(_vm.search, "to", $$v)
      },
      expression: "search.to"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.searchClick,
      "iconclass": "fa fa-search",
      "className": "btn btn-white",
      "label": "Keresés"
    },
    model: {
      value: (_vm.searching_in_progress),
      callback: function($$v) {
        _vm.searching_in_progress = $$v
      },
      expression: "searching_in_progress"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.logs.length) ? _c('div', [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(log.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.typeDisplay(log.process)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-white medium",
      attrs: {
        "target": "_blank",
        "to": 'card/edit/?id=' + log.jsondata.card_id
      }
    }, [_vm._v(_vm._s(_vm.cardNumber(log.jsondata.card_number, log.jsondata.card_type)))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-white medium",
      attrs: {
        "target": "_blank",
        "to": 'card_owner/edit/?id=' + log.jsondata.card_owner_id
      }
    }, [_vm._v(_vm._s(_vm.cardOwnerName(log.jsondata.card_owner_name, log.jsondata.card_owner_email)))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateTimeFormat(log.created)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateTimeFormat(log.executed_time)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.admin_name) + " (" + _vm._s(log.admin_email) + ")")])])
  }), 0)]), _vm._v(" "), _c('pagination', {
    attrs: {
      "showcombo": "1",
      "limit": _vm.query.limit,
      "amount": _vm.query.amount
    },
    on: {
      "pageChanged": _vm.pageChanged
    },
    model: {
      value: (_vm.query.page),
      callback: function($$v) {
        _vm.$set(_vm.query, "page", $$v)
      },
      expression: "query.page"
    }
  })], 1) : _c('div', [_vm._v("\n                  Nem található log.\n                ")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("Kezdőőoldal")]), _vm._v(" "), _c('li', [_vm._v("Log")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")]), _vm._v("Log")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Log")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel-sub-heading"
  }, [_c('h4', [_vm._v("Kereső")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Típus")]), _vm._v(" "), _c('th', [_vm._v("Kártyaszám")]), _vm._v(" "), _c('th', [_vm._v("Kártyabirtokos")]), _vm._v(" "), _c('th', [_vm._v("Létehozva")]), _vm._v(" "), _c('th', [_vm._v("Lefutott")]), _vm._v(" "), _c('th', [_vm._v("Admin")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61d4fdc1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/log.vue
// module id = 57
// module chunks = 0